import be, { createContext as In, useCallback as xn, useContext as jn, useEffect as N, useMemo as R, useState as _e, useRef as ei } from "react";
import { ModalRoot as ti, ModalPortal as ri, ModalOverlay as ni, ModalContent as ii, Text as k, ModalClose as si, Button as ne, ModalTitle as oi, Title as ai, Skeleton as M, ModalDescription as ci, ButtonClean as ui, Badge as li, ModalFooter as di, SectionSubHeader as fi, SectionTitle as pi, PriceButtonGroup as vi, PriceButton as hi, ModalMain as je, CollapsibleSectionRoot as mi, CollapsibleSectionTitle as bi, CollapsibleSectionContent as _i, Alert as gi, Typography as Si } from "@sb/ui/components";
import * as yi from "@wh/message-bus";
import { publish as At, subscribe as wn, unsubscribe as Tn } from "@wh/message-bus";
import { BetBuilder as Ii, Close as xi, ArrowDownSlim as ji, Remove as wi, InfoCircle as Ti } from "@sb/ui/icons";
import { RacingTable as ie } from "@sb/meetings";
import { ErrorResult as Oi } from "@sb/ui/templates";
import './index.css';function Ri(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var we = { exports: {} }, Y = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zt;
function ki() {
  if (zt) return Y;
  zt = 1;
  var e = be, t = 60103;
  if (Y.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    t = r("react.element"), Y.Fragment = r("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(l, c, u) {
    var d, f = {}, p = null, v = null;
    u !== void 0 && (p = "" + u), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (v = c.ref);
    for (d in c) o.call(c, d) && !s.hasOwnProperty(d) && (f[d] = c[d]);
    if (l && l.defaultProps) for (d in c = l.defaultProps, c) f[d] === void 0 && (f[d] = c[d]);
    return { $$typeof: t, type: l, key: p, ref: v, props: f, _owner: n.current };
  }
  return Y.jsx = i, Y.jsxs = i, Y;
}
var Kt;
function Bi() {
  return Kt || (Kt = 1, we.exports = ki()), we.exports;
}
var a = Bi(), C = /* @__PURE__ */ ((e) => (e.HorseRacing = "OB_SP43", e))(C || {}), E = /* @__PURE__ */ ((e) => (e.Unknown = "UNKNOWN", e.EmptyMarkets = "EMPTY_MARKETS", e.ImpossibleCombination = "IMPOSSIBLE_COMBINATION", e.Implied = "IMPLIED", e))(E || {}), y = /* @__PURE__ */ ((e) => (e.TopN = "TOP_N", e.ToFinishNth = "TO_FINISH_NTH", e.HeadToHead = "HEAD_TO_HEAD", e.BettingWithoutOne = "BETTING_WITHOUT_ONE", e.BettingWithoutTwo = "BETTING_WITHOUT_TWO", e.Distance = "TO_BE_WON_BY", e))(y || {});
const Mi = (e) => e.category === "TOP_N", Di = (e) => e.category === "TO_FINISH_NTH", Ei = (e) => e.category === "HEAD_TO_HEAD", qi = (e) => e.category === "BETTING_WITHOUT_ONE", Ni = (e) => e.category === "BETTING_WITHOUT_TWO", Ai = (e) => e.category === "TO_BE_WON_BY", On = {
  header: {
    name: "Bet Builder",
    explainer: "Add between {{min}} and {{max}} selections to Bet Builder",
    starting_soon: "Starting soon"
  },
  betslip: {
    selection: "Selection",
    selections: "Selections",
    view_selections: "View Selections",
    add_to_betslip: "Add to BetSlip",
    update_betslip: "Update BetSlip",
    bet_builder: "Bet Builder",
    suspended_selection_msg: "The conditions on one or more of your selections have changed, please edit your selections",
    one_more_selection_msg: "Add at least one more selection to create a Bet Builder",
    clear_selections: "Clear Selections",
    review: "Review",
    more_selection: "More Selection",
    more_selections: "More Selections"
  },
  disclaimers: {
    [C.HorseRacing]: "In the event of any non-runners, all Bet Builders will be recalculated based on the revised odds available in the market after withdrawal"
  },
  racing: {
    runners: "runners",
    class: "Class",
    type: {
      J: "Jumps",
      F: "Flat"
    },
    track: {
      F: "Firm",
      FT: "Fast",
      FZ: "Frozen",
      G: "Good",
      GF: "Good To Firm",
      GS: "Good To Soft",
      GY: "Good To Yielding",
      HD: "Hard",
      HO: "Holding",
      HY: "Heavy",
      MY: "Muddy",
      S: "Soft",
      SD: "Standard",
      SF: "Standard To Fast",
      SH: "Soft To Heavy",
      SN: "Sand",
      SS: "Standard To Slow",
      SW: "Slow",
      SY: "Sloppy",
      VS: "Very Soft",
      Y: "Yielding",
      YS: "Yielding To Soft"
    },
    explainers: {
      [y.TopN]: "Your bet is a winner if your selection either wins, or finishes within the number of stated places.",
      [y.ToFinishNth]: "Your bet is a winner if your selection finishes the race in the stated position.",
      [y.HeadToHead]: "Your bet is a winner if your selection finishes ahead of the other named selection.",
      [y.BettingWithoutOne]: "Back a selection to win - bets are settled ignoring the position of the 'without' runner.",
      [y.BettingWithoutTwo]: "Back a selection to win - bets are settled ignoring the position of the 'without' runner.",
      [y.Distance]: "Your bet is a winner if the winning horse wins the race by the distance you select"
    }
  },
  error: {
    title: "Oops!",
    close: "Go back",
    description: {
      [E.Unknown]: "Something went wrong. Please try again later.",
      [E.ImpossibleCombination]: "Sorry, your last selection cannot be combined",
      [E.Implied]: "Sorry, your last selection cannot be combined",
      [E.EmptyMarkets]: "No markets available to build your bet."
    },
    market_combination_error: "This market cannot be combined with your current selection(s)."
  }
}, Rn = In(On), Ci = ({
  children: e,
  translations: t = On
}) => /* @__PURE__ */ a.jsx(Rn.Provider, { value: t, children: e }), Pi = () => {
  const e = jn(Rn);
  if (!e)
    throw new Error(
      "[useTranslations] must be used within the [TranslationsProvider]"
    );
  return e;
}, O = () => {
  const e = Pi();
  return xn(
    (t, r) => {
      const n = t.split(".");
      let o = e;
      for (const s of n)
        o && typeof o == "object" && s in o ? o = o[s] : (console.warn(`[useTranslate] Missing translation for key: ${t}`), o = t);
      return !r || typeof o != "string" ? o : o.replace(/\{\{(\w+)\}\}/g, (s, i) => i in r ? String(r[i]) : (console.warn(
        `[useTranslate] Missing variable '${i}' for key: ${t}`
      ), s));
    },
    [e]
  );
}, $i = {}, Fi = (e) => {
  let t;
  const r = /* @__PURE__ */ new Set(), n = (d, f) => {
    const p = typeof d == "function" ? d(t) : d;
    if (!Object.is(p, t)) {
      const v = t;
      t = f ?? (typeof p != "object" || p === null) ? p : Object.assign({}, t, p), r.forEach((b) => b(t, v));
    }
  }, o = () => t, c = { setState: n, getState: o, getInitialState: () => u, subscribe: (d) => (r.add(d), () => r.delete(d)), destroy: () => {
    ($i ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), r.clear();
  } }, u = t = e(n, o, c);
  return c;
}, Li = (e) => Fi;
var Te = { exports: {} }, Oe = {}, Re = { exports: {} }, ke = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jt;
function Hi() {
  if (Jt) return ke;
  Jt = 1;
  var e = be;
  function t(f, p) {
    return f === p && (f !== 0 || 1 / f === 1 / p) || f !== f && p !== p;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useState, o = e.useEffect, s = e.useLayoutEffect, i = e.useDebugValue;
  function l(f, p) {
    var v = p(), b = n({ inst: { value: v, getSnapshot: p } }), h = b[0].inst, m = b[1];
    return s(
      function() {
        h.value = v, h.getSnapshot = p, c(h) && m({ inst: h });
      },
      [f, v, p]
    ), o(
      function() {
        return c(h) && m({ inst: h }), f(function() {
          c(h) && m({ inst: h });
        });
      },
      [f]
    ), i(v), v;
  }
  function c(f) {
    var p = f.getSnapshot;
    f = f.value;
    try {
      var v = p();
      return !r(f, v);
    } catch {
      return !0;
    }
  }
  function u(f, p) {
    return p();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : l;
  return ke.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : d, ke;
}
var Zt;
function Wi() {
  return Zt || (Zt = 1, Re.exports = Hi()), Re.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qt;
function Ui() {
  if (Qt) return Oe;
  Qt = 1;
  var e = be, t = Wi();
  function r(u, d) {
    return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : r, o = t.useSyncExternalStore, s = e.useRef, i = e.useEffect, l = e.useMemo, c = e.useDebugValue;
  return Oe.useSyncExternalStoreWithSelector = function(u, d, f, p, v) {
    var b = s(null);
    if (b.current === null) {
      var h = { hasValue: !1, value: null };
      b.current = h;
    } else h = b.current;
    b = l(
      function() {
        function _(I) {
          if (!g) {
            if (g = !0, S = I, I = p(I), v !== void 0 && h.hasValue) {
              var T = h.value;
              if (v(T, I))
                return w = T;
            }
            return w = I;
          }
          if (T = w, n(S, I)) return T;
          var q = p(I);
          return v !== void 0 && v(T, q) ? (S = I, T) : (S = I, w = q);
        }
        var g = !1, S, w, x = f === void 0 ? null : f;
        return [
          function() {
            return _(d());
          },
          x === null ? void 0 : function() {
            return _(x());
          }
        ];
      },
      [d, f, p, v]
    );
    var m = o(u, b[0], b[1]);
    return i(
      function() {
        h.hasValue = !0, h.value = m;
      },
      [m]
    ), c(m), m;
  }, Oe;
}
var Xt;
function Vi() {
  return Xt || (Xt = 1, Te.exports = Ui()), Te.exports;
}
var Yi = Vi();
const Gi = /* @__PURE__ */ Ri(Yi), { useDebugValue: zi } = be, { useSyncExternalStoreWithSelector: Ki } = Gi, Ji = (e) => e;
function Zi(e, t = Ji, r) {
  const n = Ki(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    r
  );
  return zi(n), n;
}
const kn = async (e, t = {}, r) => {
  const n = new URLSearchParams();
  for (const s in t) {
    const i = t[s];
    i != null && n.append(s, String(i));
  }
  return (await fetch(
    n.size ? `${e}?${n.toString()}` : e,
    r
  )).json();
}, D = (e) => (e || "").replace(/\|/g, ""), Qi = (e, t) => {
  let r = -1;
  return (e || "").replace(/<([^>]+)>/g, (n) => {
    const o = r + 1;
    return r++, t[o] !== void 0 ? t[o] : n;
  });
}, Xi = (e) => [C.HorseRacing].includes(e), es = {
  [C.HorseRacing]: "horse-racing"
}, ts = ({
  environment: e,
  jurisdiction: t,
  locale: r,
  sportId: n
}) => {
  const o = `https://sports.williamhill${e === "prd" ? "" : `-${e}`}.${t}/data/bet-builder/${es[n]}/${r}`;
  return {
    baseUrl: o,
    getMarkets: (s) => kn(`${o}/event/${s}/markets`)
  };
}, ue = (e, t) => {
  var n;
  const r = (n = e == null ? void 0 : e.selections) == null ? void 0 : n[t];
  return !r || r.priceNum == null || r.priceDen == null || r.priceDen === 0 ? 1 / 0 : r.priceNum / r.priceDen;
}, ge = (e, t) => ue(e, 0) - ue(t, 0) || ue(e, 1) - ue(t, 1);
function rs(e, t) {
  const r = new Map(
    e.map((n, o) => [n, o])
  );
  return (n, o) => {
    const s = t ? t(n) : n, i = t ? t(o) : o, l = r.get(s), c = r.get(i);
    return l === void 0 && c === void 0 ? 0 : l === void 0 ? 1 : c === void 0 ? -1 : l - c;
  };
}
const ns = (e, t) => {
  const r = [], n = [], o = [];
  return {
    byoData: {
      ...e,
      sportId: C.HorseRacing,
      byoMarketGroups: e.byoMarketGroups.map((i) => {
        var l;
        if (Mi(i) || Di(i)) {
          const c = i.category, u = D(i.categoryName), d = {
            id: c,
            category: i.category,
            categoryName: u,
            outcomes: (l = i.outcomes) == null ? void 0 : l.map(D),
            markets: Object.keys(i.markets).reduce((f, p) => {
              const v = Array.isArray(i.markets[p]) ? i.markets[p][0] : i.markets[p], b = D(p), h = v.selections.map(
                (_) => ({
                  ..._,
                  name: D(_.name),
                  details: [u, b],
                  eventId: e.id,
                  marketId: v.id,
                  marketGroupId: c
                })
              ), m = {
                ...v,
                selectionIds: h.map((_) => _.id),
                category: i.category,
                groupId: c
              };
              return r.push(m), o.push(...h), { ...f, [b]: m };
            }, {})
          };
          return n.push(d), d;
        }
        if (Ei(i)) {
          const c = i.category, u = D(i.categoryName), d = {
            id: c,
            category: i.category,
            categoryName: u,
            competitors: i.competitors,
            markets: Object.keys(i.markets).reduce((f, p) => {
              const v = Array.isArray(i.markets[p]) ? i.markets[p][0] : i.markets[p], b = D(p), h = v.selections.map(
                (_) => ({
                  ..._,
                  name: D(_.name),
                  details: [b],
                  eventId: e.id,
                  marketId: v.id,
                  marketGroupId: c
                })
              ), m = {
                ...v,
                selectionIds: h.map((_) => _.id),
                category: i.category,
                groupId: c
              };
              return r.push(m), o.push(...h), { ...f, [b]: m };
            }, {})
          };
          return n.push(d), d;
        }
        if (Ai(i)) {
          const c = Object.values(i.markets)[0], u = Array.isArray(c) ? c[0] : c, d = D(i.categoryName), f = i.category, p = u.selections.map((h) => ({
            ...h,
            name: D(h.name),
            details: [d],
            eventId: e.id,
            marketId: u.id,
            marketGroupId: f
          })), v = {
            ...u,
            selectionIds: p.map((h) => h.id),
            category: i.category,
            groupId: f
          };
          r.push(v), o.push(...p);
          const b = {
            id: f,
            category: i.category,
            categoryName: d,
            markets: v
          };
          return n.push(b), b;
        }
        if (qi(i) || Ni(i)) {
          const c = Object.keys(i.markets).map((u) => {
            const d = Array.isArray(i.markets[u]) ? i.markets[u][0] : i.markets[u], f = D(
              Qi(i.categoryName, [u])
            ), p = i.category + u, v = d.selections.map((h) => ({
              ...h,
              name: D(h.name),
              details: [f],
              eventId: e.id,
              marketId: d.id,
              marketGroupId: p
            })), b = {
              ...d,
              selectionIds: v.map((h) => h.id),
              category: i.category,
              groupId: p
            };
            return r.push(b), o.push(...v), {
              id: p,
              category: i.category,
              categoryName: f,
              competitors: i.competitors,
              markets: b
            };
          });
          return n.push(...c), c;
        }
        return null;
      }).flat().filter((i) => !!i)
    },
    markets: r,
    marketGroups: n.sort(
      rs(
        [
          y.TopN,
          y.HeadToHead,
          y.ToFinishNth,
          y.Distance,
          y.BettingWithoutOne,
          y.BettingWithoutTwo
        ],
        (i) => i.category
      )
    ),
    selections: o,
    config: {
      minSelections: 2,
      maxSelections: 10,
      ...t
    }
  };
}, is = {
  [C.HorseRacing]: ns
}, Bn = (e, t) => {
  const r = is[t.sportId];
  if (!r)
    throw new Error(`No mapper found for ${t.sportId}`);
  return r(e, t);
}, ss = (e) => typeof e == "object" && e !== null && "error" in e && typeof e.error == "object" && e.error !== null && "errorCode" in e.error && typeof e.error.errorCode == "string", os = ({
  environment: e,
  jurisdiction: t
}) => {
  const r = `https://transact.williamhill${e === "prd" ? "" : `-${e}`}.${t}/betslip/api`;
  return {
    baseUrl: r,
    getByoPrice: (n) => kn(`${r}/bets/getByoPrice`, void 0, {
      method: "POST",
      body: JSON.stringify(n),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    })
  };
}, as = async (e, t) => {
  var n, o, s;
  if (!e.config || !e.byoData)
    throw new Error("Store is not properly initialized");
  const r = await os(e.config).getByoPrice({
    eventID: e.byoData.gtpId,
    selections: t.map((i) => ({
      selectionId: i.gtpId,
      handicap: i.handicap
    })),
    combinationIdCheckValue: ((o = (n = e.priceSubscription) == null ? void 0 : n.topic) == null ? void 0 : o.split("/").pop()) || ""
  });
  if (ss(r)) {
    const { error: i } = r, l = Object.values(E).includes(
      i.errorCode
    );
    return {
      error: {
        ...i,
        errorCode: l ? i.errorCode : E.Unknown
      },
      price: null,
      byoMarketId: null,
      priceSubscription: null
    };
  }
  return {
    error: null,
    price: r.selection.price,
    byoMarketId: r.selection.byoMarketId,
    priceSubscription: (s = r.priceSubscription) != null && s.topic ? r.priceSubscription : null
  };
}, cs = (e) => ({
  getByoPrice: (t) => as(e, t),
  getUpdatedSelections: (t) => {
    var s;
    const { getActiveSelections: r } = e, n = r(), o = (s = e.markets.find(
      (i) => i.id === t.marketId
    )) == null ? void 0 : s.category;
    return o === y.HeadToHead || o === y.ToFinishNth || o === y.BettingWithoutOne || o === y.BettingWithoutTwo ? n.some((i) => i.marketId === t.marketId) ? n.map(
      (i) => i.marketId === t.marketId ? t : i
    ) : [...n, t] : [...n, t];
  },
  getIncompatibleMarketGroups: () => []
}), us = {
  [C.HorseRacing]: cs
}, er = (e) => {
  if (!e.config)
    throw new Error("Config is not set");
  const t = us[e.config.sportId];
  if (!t)
    throw new Error(`No helper found for ${e.config.sportId}`);
  return t(e);
}, tr = {
  byoMarketId: null,
  byoData: null,
  config: null,
  price: null,
  priceSubscription: null,
  error: null,
  markets: [],
  marketGroups: [],
  selections: [],
  activeSelectionIds: [],
  visibleMarketGroupIds: [],
  incompatibleMarketGroupIds: [],
  isBetslipExpanded: !1,
  isLoading: !1,
  isInitialized: !1
}, Q = Li()((e, t) => ({
  ...tr,
  initialize: async (r) => {
    var s, i, l;
    const n = t();
    ((s = n.config) == null ? void 0 : s.eventId) === r.eventId && !n.error && !n.config.betslipBetId && !r.betslipBetId && !((i = r.initialSelections) != null && i.length) && (r.initialSelections = n.getSelections(n.activeSelectionIds).map((c) => c.gtpId)), e({ ...tr, isLoading: !0 });
    try {
      const c = await ts(r).getMarkets(
        r.eventId
      ), u = Bn(c, r);
      if (u.markets.every((b) => !b.active))
        return e({
          isLoading: !1,
          error: { errorCode: E.EmptyMarkets }
        });
      if (e(u), (l = r.initialSelections) != null && l.length) {
        const { setActiveSelections: b, selections: h } = t();
        await b(
          h.filter((m) => {
            var _;
            return (_ = r.initialSelections) == null ? void 0 : _.includes(m.gtpId);
          }).map((m) => m.id)
        );
      }
      const { activeSelectionIds: d, isMarketGroupSuspended: f, getSelection: p } = t(), v = u.marketGroups.filter((b) => !f(b.id)).filter((b, h) => d.length ? d.map(p).some((m) => (m == null ? void 0 : m.marketGroupId) === b.id) : h === 0);
      e({
        visibleMarketGroupIds: v.map((b) => b.id),
        isInitialized: t().error === null,
        isLoading: !1
      });
    } catch (c) {
      console.error(c), e({
        isInitialized: !1,
        isLoading: !1,
        error: { errorCode: E.Unknown }
      });
    }
  },
  addSelection: async (r) => {
    const n = t(), o = n.getSelection(r);
    if (!o)
      throw new Error(`Selection with id ${r} not found`);
    const s = er(n).getUpdatedSelections(o).map((i) => i.id);
    await n.setActiveSelections(s);
  },
  removeSelection: async (r) => {
    const { activeSelectionIds: n, setActiveSelections: o } = t(), s = n.filter((i) => i !== r);
    await o(s);
  },
  toggleSelection: async (r) => {
    const { activeSelectionIds: n, addSelection: o, removeSelection: s } = t();
    n.some((i) => i === r) ? await s(r) : await o(r);
  },
  clearActiveSelections: () => {
    t().setActiveSelections([]);
  },
  setActiveSelections: async (r) => {
    const n = t(), { config: o, getSelections: s } = n, i = s(r);
    if (!o)
      throw new Error("Config is not set");
    if (i.length > o.maxSelections)
      return;
    const { getIncompatibleMarketGroups: l, getByoPrice: c } = er(n);
    if (i.length < o.minSelections)
      return e({
        incompatibleMarketGroupIds: l(i),
        activeSelectionIds: i.map((u) => u.id),
        error: null,
        price: null,
        priceSubscription: null,
        byoMarketId: null,
        isBetslipExpanded: i.length ? n.isBetslipExpanded : !1
      });
    try {
      const u = await c(i);
      if (u.error)
        return e({ error: u.error });
      e({
        incompatibleMarketGroupIds: l(i),
        activeSelectionIds: i.map((d) => d.id),
        price: u.price,
        byoMarketId: u.byoMarketId,
        priceSubscription: u.priceSubscription,
        error: null
      });
    } catch (u) {
      console.error(u), e({
        error: { errorCode: E.Unknown }
      });
    }
  },
  setIsBetslipExpanded: (r) => {
    e({ isBetslipExpanded: r });
  },
  setVisibleMarketGroups: (r) => {
    e({ visibleMarketGroupIds: r });
  },
  getSelection: (r) => t().selections.find((n) => n.id === r),
  getSelections: (r) => {
    const { getSelection: n } = t();
    return r.map(n).filter((o) => !!o);
  },
  getActiveSelections: () => {
    const { activeSelectionIds: r, getSelections: n } = t();
    return n(r);
  },
  isSelected: (r) => t().activeSelectionIds.some((n) => n === r),
  isDisabled: (r) => {
    const {
      config: n,
      activeSelectionIds: o,
      selections: s,
      isSelected: i,
      isMarketGroupIncompatible: l,
      isMarketGroupSuspended: c,
      isMarketSuspended: u,
      isEventSuspended: d
    } = t();
    if (i(r))
      return !1;
    if (n && o.length >= n.maxSelections)
      return !0;
    const f = s.find((p) => p.id === r);
    return !f || !f.active || d() || u(f.marketId) || c(f.marketGroupId) || l(f.marketId);
  },
  isEventSuspended: () => {
    var r;
    return !((r = t().byoData) != null && r.active);
  },
  isMarketSuspended: (r) => {
    const n = t().markets.find((o) => o.id === r);
    return !(n != null && n.active);
  },
  isMarketGroupSuspended: (r) => t().markets.filter((o) => o.groupId === r).every((o) => !o.active),
  isMarketGroupIncompatible: (r) => t().incompatibleMarketGroupIds.includes(r),
  addToBetslip: () => {
    const {
      price: r,
      byoData: n,
      byoMarketId: o,
      getActiveSelections: s,
      clearActiveSelections: i
    } = t();
    if (!r || !n)
      throw new Error("Cannot add to betslip: missing data");
    At("wh.sports.betslip.adapter.byo.legs.add", {
      byoEventId: n.gtpId,
      byoMarketId: o,
      byoPrice: {
        type: r.type,
        numerator: r.numerator,
        denominator: r.denominator
      },
      byoSelectionDetails: s().map((l) => ({
        selectionId: l.gtpId,
        handicap: l.handicap
      }))
    }), i();
  },
  updateBetslip: () => {
    const {
      config: r,
      price: n,
      byoData: o,
      byoMarketId: s,
      getActiveSelections: i,
      clearActiveSelections: l
    } = t();
    if (!(r != null && r.betslipBetId) || !n || !o)
      throw new Error("Cannot update betslip: missing data");
    At("wh.sports.betslip.adapter.byo.legs.edit", {
      id: r.betslipBetId,
      data: {
        byoEventId: o.gtpId,
        byoMarketId: s,
        byoPrice: {
          type: n.type,
          numerator: n.numerator,
          denominator: n.denominator
        },
        byoSelectionDetails: i().map((c) => ({
          selectionId: c.gtpId,
          handicap: c.handicap
        }))
      }
    }), l();
  }
}));
function j() {
  return Zi(Q);
}
const Mn = In({
  open: !1,
  onOpenChange: () => {
  }
}), ls = ({
  open: e,
  onOpenChange: t,
  children: r
}) => {
  const n = j();
  N(() => {
    n.isInitialized && n.marketGroups.every((s) => n.isMarketGroupSuspended(s.id)) && t(!1);
  }, [n, t]);
  const o = R(
    () => ({
      open: e,
      onOpenChange: t
    }),
    [e, t]
  );
  return /* @__PURE__ */ a.jsx(Mn.Provider, { value: o, children: r });
}, Pt = () => {
  const e = jn(Mn);
  if (!e)
    throw new Error(
      "[useBetBuilderModalContext] must be used within a [BetBuilderModalProvider]"
    );
  return e;
}, ds = "sb-bet-builder-content__EkLmO", rr = {
  content: ds
}, fs = ({
  children: e
}) => {
  const { open: t, onOpenChange: r } = Pt();
  return /* @__PURE__ */ a.jsx(ti, { open: t, onOpenChange: r, children: /* @__PURE__ */ a.jsx(ri, { children: /* @__PURE__ */ a.jsx(ni, { className: rr.overlay, children: /* @__PURE__ */ a.jsx(
    ii,
    {
      className: rr.content,
      "data-test-id": "bet-builder-modal",
      children: e
    }
  ) }) }) });
};
function Dn(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = Dn(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function Z() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = Dn(e)) && (n && (n += " "), n += t);
  return n;
}
const ps = "sb-bet-builder-container__nfwjX", vs = {
  container: ps
}, hs = ["m", "s"], nr = (e) => {
  if (e == null)
    return;
  const t = +new Date(e) - +/* @__PURE__ */ new Date();
  return t <= 1500 ? null : {
    h: Math.floor(t / (1e3 * 60 * 60)),
    m: Math.floor(t / 1e3 / 60 % 60),
    s: Math.floor(t / 1e3 % 60)
  };
}, ms = ({
  target: e,
  maxMinutesDifference: t = 30
}) => {
  const [r, n] = _e(nr(e));
  N(() => {
    const s = setTimeout(() => {
      n(nr(e));
    }, 1e3);
    return () => clearTimeout(s);
  }, [e, r]);
  const o = O();
  return ((r == null ? void 0 : r.h) ?? 0) > 0 || ((r == null ? void 0 : r.m) ?? 0) >= t ? null : /* @__PURE__ */ a.jsx(k, { className: vs.container, variant: "captionPrimary", children: r == null ? o("header.starting_soon") : hs.map((s) => /* @__PURE__ */ a.jsxs("span", { children: [
    r[s],
    s
  ] }, s)) });
}, bs = (e = -1, t = -1, r = -1) => Number(e) > 0 || Number(t) > 0 || Number(r) > 0, _s = (e = -1, t = -1, r = -1) => {
  const n = Number(e) > 0 && e + "m" || "", o = Number(t) > 0 && t + "f" || "", s = Number(r) > 0 && r + "y" || "";
  return [n, o, s].join(" ");
}, gs = () => {
  const e = O(), { byoData: t } = j(), r = R(() => {
    const { race: n, runners: o } = t.metadata || {}, s = [];
    return n != null && n.class && n.class !== "-" && s.push(`${e("racing.class")} ${n.class}`), n != null && n.type && s.push(e(`racing.type.${n.type}`)), o && Object.keys(o).length && s.push(`${Object.keys(o).length} ${e("racing.runners")}`), n && bs(n.distM, n.distF, n.distY) && s.push(_s(n.distM, n.distF, n.distY)), n != null && n.going && s.push(e(`racing.track.${n.going}`)), n != null && n.prize && s.push(`£${Math.round(n.prize).toLocaleString()}`), s;
  }, [e, t]);
  return /* @__PURE__ */ a.jsx(a.Fragment, { children: r.join(" • ") });
}, Ss = {
  [C.HorseRacing]: gs
}, ys = {
  "en-gb": "Europe/London",
  "es-es": "Europe/Madrid"
}, Is = (e, t) => {
  if (!e)
    return "";
  const r = new Date(e), n = {
    hour: "2-digit",
    minute: "2-digit"
  }, o = ys[t.toLowerCase()];
  return o && (n.timeZone = o), r.toLocaleTimeString(t, n);
}, xs = "sb-bet-builder-container__ftq--", js = "sb-bet-builder-nameContainer__msklp", ws = "sb-bet-builder-name__ch-83", Ts = "sb-bet-builder-close__vonwl", Os = "sb-bet-builder-title__ycqbu", Rs = "sb-bet-builder-description__mM5l2", G = {
  container: xs,
  nameContainer: js,
  name: ws,
  close: Ts,
  title: Os,
  description: Rs
}, ks = () => {
  const { config: e, byoData: t, isLoading: r } = j(), n = O(), o = R(
    () => e ? Ss[e.sportId] : null,
    [e]
  );
  return /* @__PURE__ */ a.jsxs("header", { className: G.container, "data-test-id": "bet-builder-header", children: [
    /* @__PURE__ */ a.jsxs("div", { className: Z(G.nameContainer), children: [
      /* @__PURE__ */ a.jsxs("span", { className: G.name, children: [
        /* @__PURE__ */ a.jsx(Ii, { size: 24 }),
        " ",
        n("header.name")
      ] }),
      /* @__PURE__ */ a.jsx(si, { asChild: !0, children: /* @__PURE__ */ a.jsx(ne, { variant: "ghost", size: "icon", className: G.close, children: /* @__PURE__ */ a.jsx(xi, { size: 12 }) }) })
    ] }),
    (t || r) && /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsx(oi, { asChild: !0, children: /* @__PURE__ */ a.jsx(ai, { level: 3, className: Z(G.title), children: e && t && !r ? /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
        Is(t.startDateTime, e.locale),
        " ",
        (t.name || "").replace(/^\d+:\d+\s*/, ""),
        Xi(t.sportId) && /* @__PURE__ */ a.jsx(ms, { target: t.startDateTime })
      ] }) : /* @__PURE__ */ a.jsx(M, { width: 180, height: 18 }) }) }),
      /* @__PURE__ */ a.jsx(ci, { asChild: !0, children: /* @__PURE__ */ a.jsx(k, { className: Z(G.description), children: t && !r && o ? /* @__PURE__ */ a.jsx(o, {}) : /* @__PURE__ */ a.jsx(M, { width: 300, height: 14 }) }) })
    ] })
  ] });
}, Bs = "sb-bet-builder-preBetslip__fkAuM", Ms = {
  preBetslip: Bs
}, Ds = "sb-bet-builder-header__L04WS", Es = "sb-bet-builder-text__k7UZ7", qs = "sb-bet-builder-arrow__lBKn7", Be = {
  header: Ds,
  text: Es,
  arrow: qs
}, Ns = () => {
  const e = O(), { setIsBetslipExpanded: t } = j();
  return /* @__PURE__ */ a.jsxs(
    ui,
    {
      className: Be.header,
      onClick: () => t(!1),
      children: [
        /* @__PURE__ */ a.jsx(k, { className: Be.text, children: e("betslip.review") }),
        /* @__PURE__ */ a.jsx(ji, { size: 16, className: Be.arrow })
      ]
    }
  );
}, As = "sb-bet-builder-container__6xhWy", Cs = "sb-bet-builder-selectionsInfo__-z-rf", Ps = "sb-bet-builder-clearButton__E0c6Z", $s = "sb-bet-builder-badge__NYRB-", Fs = "sb-bet-builder-selectionsNumber__lG-0i", re = {
  container: As,
  selectionsInfo: Cs,
  clearButton: Ps,
  badge: $s,
  selectionsNumber: Fs
}, Ls = () => {
  const { activeSelectionIds: e, clearActiveSelections: t } = j(), r = O();
  return e.length === 0 ? null : /* @__PURE__ */ a.jsxs("div", { className: re.container, children: [
    /* @__PURE__ */ a.jsxs("div", { className: re.selectionsInfo, children: [
      /* @__PURE__ */ a.jsx("div", { className: re.selectionsNumber, children: /* @__PURE__ */ a.jsx("div", { className: re.badge, children: /* @__PURE__ */ a.jsx(li, { variant: "error", children: e.length }) }) }),
      /* @__PURE__ */ a.jsx(k, { children: e.length === 1 ? r("betslip.selection") : r("betslip.selections") })
    ] }),
    /* @__PURE__ */ a.jsx(
      ne,
      {
        className: re.clearButton,
        variant: "link",
        onClick: () => t(),
        children: r("betslip.clear_selections")
      }
    )
  ] });
}, Hs = "sb-bet-builder-buttonDelete__Fn9Vq", Ws = "sb-bet-builder-item__rgLRo", Us = "sb-bet-builder-selection__Smfor", Vs = "sb-bet-builder-selectionTitle__Ul6L1", Ys = "sb-bet-builder-selectionCategory__6Vqew", Gs = "sb-bet-builder-list__Fbd4s", z = {
  buttonDelete: Hs,
  item: Ws,
  selection: Us,
  selectionTitle: Vs,
  selectionCategory: Ys,
  list: Gs
}, zs = () => {
  const { getActiveSelections: e, removeSelection: t } = j(), r = e();
  return /* @__PURE__ */ a.jsx("div", { className: z.list, children: r.map((n) => /* @__PURE__ */ a.jsxs("div", { className: z.item, children: [
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: z.buttonDelete,
        onClick: () => t(n.id),
        children: /* @__PURE__ */ a.jsx(wi, {})
      }
    ),
    /* @__PURE__ */ a.jsxs("div", { className: z.selection, children: [
      /* @__PURE__ */ a.jsx("span", { className: z.selectionTitle, children: n.name }),
      /* @__PURE__ */ a.jsx("div", { className: z.selectionCategory, children: n.details.join(" - ") })
    ] })
  ] }, n.id)) });
}, Ks = "sb-bet-builder-error__4JSfn", Js = {
  error: Ks
}, En = () => {
  const e = O(), { error: t } = j();
  return t ? /* @__PURE__ */ a.jsx("div", { className: Js.error, children: /* @__PURE__ */ a.jsx(k, { children: e(`error.description.${t.errorCode}`) }) }) : null;
}, Zs = () => /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
  /* @__PURE__ */ a.jsx(Ns, {}),
  /* @__PURE__ */ a.jsx(En, {}),
  /* @__PURE__ */ a.jsx(Ls, {}),
  /* @__PURE__ */ a.jsx(zs, {})
] }), Qs = "sb-bet-builder-container__Tb6pq", Xs = "sb-bet-builder-headerText__7lHIb", ir = {
  container: Qs,
  headerText: Xs
}, eo = "sb-bet-builder-container__FA0aC", to = "sb-bet-builder-selectionsList__GwJ7j", ro = "sb-bet-builder-showTimeline__3QBRy", no = "sb-bet-builder-moreSelections__fhtVr", le = {
  container: eo,
  selectionsList: to,
  showTimeline: ro,
  moreSelections: no
}, io = "sb-bet-builder-item__-pGiL", so = "sb-bet-builder-name__7nDL3", oo = "sb-bet-builder-subtitle__XVXuz", Me = {
  item: io,
  name: so,
  subtitle: oo
}, ao = ({ selection: e }) => /* @__PURE__ */ a.jsx("div", { className: Me.item, children: /* @__PURE__ */ a.jsxs(k, { className: Me.name, children: [
  e.name,
  /* @__PURE__ */ a.jsx(
    k,
    {
      className: Me.subtitle,
      children: ` - ${e.details.join(" - ")}`
    }
  )
] }) }), co = () => {
  const { getActiveSelections: e, setIsBetslipExpanded: t } = j(), r = O(), n = e(), o = n.slice(3).length, s = r(o === 1 ? "betslip.more_selection" : "betslip.more_selections");
  return /* @__PURE__ */ a.jsx("div", { className: le.container, children: /* @__PURE__ */ a.jsxs(
    "div",
    {
      className: Z(le.selectionsList, {
        [le.showTimeline]: n.length > 1
      }),
      children: [
        n.slice(0, 3).map((i) => /* @__PURE__ */ a.jsx(ao, { selection: i }, i.id)),
        n.length > 3 ? /* @__PURE__ */ a.jsx("div", { children: /* @__PURE__ */ a.jsx(
          ne,
          {
            className: le.moreSelections,
            "data-test-id": "more-selections-button",
            variant: "link",
            onClick: () => t(!0),
            children: `${o} ${s}`
          }
        ) }) : ""
      ]
    }
  ) });
}, uo = () => {
  const { activeSelectionIds: e } = j(), t = O();
  return /* @__PURE__ */ a.jsxs("div", { className: ir.container, "data-test-id": "pre-betslip-basic-view", children: [
    /* @__PURE__ */ a.jsx(k, { className: ir.headerText, children: e.length === 1 ? `${e.length} ${t("betslip.selection")}` : `${e.length} ${t("betslip.selections")}` }),
    /* @__PURE__ */ a.jsx(co, {}),
    /* @__PURE__ */ a.jsx(En, {})
  ] });
};
var A = {}, K = {}, sr;
function qn() {
  if (sr) return K;
  sr = 1, Object.defineProperty(K, "__esModule", {
    value: !0
  }), K.ODDS_FORMAT_CHANGED = "@sb/odds-format-common/ODDS_FORMAT_CHANGED";
  var e = K.ODDS_FORMATS = {
    FRACTION: "fraction",
    DECIMAL: "decimal",
    AMERICAN: "american"
  };
  return K.DEFAULT_ODDS_FORMAT = e.FRACTION, K;
}
var L = {}, de = {}, or = {}, De, ar;
function lo() {
  return ar || (ar = 1, De = function() {
  }), De;
}
var Ee, cr;
function fo() {
  return cr || (cr = 1, Ee = function(e, t) {
    return { value: t, done: !!e };
  }), Ee;
}
var qe, ur;
function se() {
  return ur || (ur = 1, qe = {}), qe;
}
var Ne, lr;
function Nn() {
  if (lr) return Ne;
  lr = 1;
  var e = {}.toString;
  return Ne = function(t) {
    return e.call(t).slice(8, -1);
  }, Ne;
}
var Ae, dr;
function po() {
  if (dr) return Ae;
  dr = 1;
  var e = Nn();
  return Ae = Object("z").propertyIsEnumerable(0) ? Object : function(t) {
    return e(t) == "String" ? t.split("") : Object(t);
  }, Ae;
}
var Ce, fr;
function $t() {
  return fr || (fr = 1, Ce = function(e) {
    if (e == null) throw TypeError("Can't call method on  " + e);
    return e;
  }), Ce;
}
var Pe, pr;
function Ft() {
  if (pr) return Pe;
  pr = 1;
  var e = po(), t = $t();
  return Pe = function(r) {
    return e(t(r));
  }, Pe;
}
var $e, vr;
function An() {
  return vr || (vr = 1, $e = !0), $e;
}
var Fe = { exports: {} }, hr;
function X() {
  if (hr) return Fe.exports;
  hr = 1;
  var e = Fe.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
  return typeof __g == "number" && (__g = e), Fe.exports;
}
var Le = { exports: {} }, mr;
function ee() {
  if (mr) return Le.exports;
  mr = 1;
  var e = Le.exports = { version: "2.6.12" };
  return typeof __e == "number" && (__e = e), Le.exports;
}
var He, br;
function vo() {
  return br || (br = 1, He = function(e) {
    if (typeof e != "function") throw TypeError(e + " is not a function!");
    return e;
  }), He;
}
var We, _r;
function ho() {
  if (_r) return We;
  _r = 1;
  var e = vo();
  return We = function(t, r, n) {
    if (e(t), r === void 0) return t;
    switch (n) {
      case 1:
        return function(o) {
          return t.call(r, o);
        };
      case 2:
        return function(o, s) {
          return t.call(r, o, s);
        };
      case 3:
        return function(o, s, i) {
          return t.call(r, o, s, i);
        };
    }
    return function() {
      return t.apply(r, arguments);
    };
  }, We;
}
var Ue = {}, Ve, gr;
function Lt() {
  return gr || (gr = 1, Ve = function(e) {
    return typeof e == "object" ? e !== null : typeof e == "function";
  }), Ve;
}
var Ye, Sr;
function Se() {
  if (Sr) return Ye;
  Sr = 1;
  var e = Lt();
  return Ye = function(t) {
    if (!e(t)) throw TypeError(t + " is not an object!");
    return t;
  }, Ye;
}
var Ge, yr;
function Cn() {
  return yr || (yr = 1, Ge = function(e) {
    try {
      return !!e();
    } catch {
      return !0;
    }
  }), Ge;
}
var ze, Ir;
function oe() {
  return Ir || (Ir = 1, ze = !Cn()(function() {
    return Object.defineProperty({}, "a", { get: function() {
      return 7;
    } }).a != 7;
  })), ze;
}
var Ke, xr;
function Pn() {
  if (xr) return Ke;
  xr = 1;
  var e = Lt(), t = X().document, r = e(t) && e(t.createElement);
  return Ke = function(n) {
    return r ? t.createElement(n) : {};
  }, Ke;
}
var Je, jr;
function mo() {
  return jr || (jr = 1, Je = !oe() && !Cn()(function() {
    return Object.defineProperty(Pn()("div"), "a", { get: function() {
      return 7;
    } }).a != 7;
  })), Je;
}
var Ze, wr;
function bo() {
  if (wr) return Ze;
  wr = 1;
  var e = Lt();
  return Ze = function(t, r) {
    if (!e(t)) return t;
    var n, o;
    if (r && typeof (n = t.toString) == "function" && !e(o = n.call(t)) || typeof (n = t.valueOf) == "function" && !e(o = n.call(t)) || !r && typeof (n = t.toString) == "function" && !e(o = n.call(t))) return o;
    throw TypeError("Can't convert object to primitive value");
  }, Ze;
}
var Tr;
function ye() {
  if (Tr) return Ue;
  Tr = 1;
  var e = Se(), t = mo(), r = bo(), n = Object.defineProperty;
  return Ue.f = oe() ? Object.defineProperty : function(s, i, l) {
    if (e(s), i = r(i, !0), e(l), t) try {
      return n(s, i, l);
    } catch {
    }
    if ("get" in l || "set" in l) throw TypeError("Accessors not supported!");
    return "value" in l && (s[i] = l.value), s;
  }, Ue;
}
var Qe, Or;
function $n() {
  return Or || (Or = 1, Qe = function(e, t) {
    return {
      enumerable: !(e & 1),
      configurable: !(e & 2),
      writable: !(e & 4),
      value: t
    };
  }), Qe;
}
var Xe, Rr;
function ae() {
  if (Rr) return Xe;
  Rr = 1;
  var e = ye(), t = $n();
  return Xe = oe() ? function(r, n, o) {
    return e.f(r, n, t(1, o));
  } : function(r, n, o) {
    return r[n] = o, r;
  }, Xe;
}
var et, kr;
function Ie() {
  if (kr) return et;
  kr = 1;
  var e = {}.hasOwnProperty;
  return et = function(t, r) {
    return e.call(t, r);
  }, et;
}
var tt, Br;
function Fn() {
  if (Br) return tt;
  Br = 1;
  var e = X(), t = ee(), r = ho(), n = ae(), o = Ie(), s = "prototype", i = function(l, c, u) {
    var d = l & i.F, f = l & i.G, p = l & i.S, v = l & i.P, b = l & i.B, h = l & i.W, m = f ? t : t[c] || (t[c] = {}), _ = m[s], g = f ? e : p ? e[c] : (e[c] || {})[s], S, w, x;
    f && (u = c);
    for (S in u)
      w = !d && g && g[S] !== void 0, !(w && o(m, S)) && (x = w ? g[S] : u[S], m[S] = f && typeof g[S] != "function" ? u[S] : b && w ? r(x, e) : h && g[S] == x ? (function(I) {
        var T = function(q, B, P) {
          if (this instanceof I) {
            switch (arguments.length) {
              case 0:
                return new I();
              case 1:
                return new I(q);
              case 2:
                return new I(q, B);
            }
            return new I(q, B, P);
          }
          return I.apply(this, arguments);
        };
        return T[s] = I[s], T;
      })(x) : v && typeof x == "function" ? r(Function.call, x) : x, v && ((m.virtual || (m.virtual = {}))[S] = x, l & i.R && _ && !_[S] && n(_, S, x)));
  };
  return i.F = 1, i.G = 2, i.S = 4, i.P = 8, i.B = 16, i.W = 32, i.U = 64, i.R = 128, tt = i, tt;
}
var rt, Mr;
function _o() {
  return Mr || (Mr = 1, rt = ae()), rt;
}
var nt, Dr;
function Ht() {
  if (Dr) return nt;
  Dr = 1;
  var e = Math.ceil, t = Math.floor;
  return nt = function(r) {
    return isNaN(r = +r) ? 0 : (r > 0 ? t : e)(r);
  }, nt;
}
var it, Er;
function go() {
  if (Er) return it;
  Er = 1;
  var e = Ht(), t = Math.min;
  return it = function(r) {
    return r > 0 ? t(e(r), 9007199254740991) : 0;
  }, it;
}
var st, qr;
function So() {
  if (qr) return st;
  qr = 1;
  var e = Ht(), t = Math.max, r = Math.min;
  return st = function(n, o) {
    return n = e(n), n < 0 ? t(n + o, 0) : r(n, o);
  }, st;
}
var ot, Nr;
function yo() {
  if (Nr) return ot;
  Nr = 1;
  var e = Ft(), t = go(), r = So();
  return ot = function(n) {
    return function(o, s, i) {
      var l = e(o), c = t(l.length), u = r(i, c), d;
      if (n && s != s) {
        for (; c > u; )
          if (d = l[u++], d != d) return !0;
      } else for (; c > u; u++) if ((n || u in l) && l[u] === s)
        return n || u || 0;
      return !n && -1;
    };
  }, ot;
}
var at = { exports: {} }, Ar;
function Ln() {
  if (Ar) return at.exports;
  Ar = 1;
  var e = ee(), t = X(), r = "__core-js_shared__", n = t[r] || (t[r] = {});
  return (at.exports = function(o, s) {
    return n[o] || (n[o] = s !== void 0 ? s : {});
  })("versions", []).push({
    version: e.version,
    mode: An() ? "pure" : "global",
    copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
  }), at.exports;
}
var ct, Cr;
function Hn() {
  if (Cr) return ct;
  Cr = 1;
  var e = 0, t = Math.random();
  return ct = function(r) {
    return "Symbol(".concat(r === void 0 ? "" : r, ")_", (++e + t).toString(36));
  }, ct;
}
var ut, Pr;
function Wt() {
  if (Pr) return ut;
  Pr = 1;
  var e = Ln()("keys"), t = Hn();
  return ut = function(r) {
    return e[r] || (e[r] = t(r));
  }, ut;
}
var lt, $r;
function Io() {
  if ($r) return lt;
  $r = 1;
  var e = Ie(), t = Ft(), r = yo()(!1), n = Wt()("IE_PROTO");
  return lt = function(o, s) {
    var i = t(o), l = 0, c = [], u;
    for (u in i) u != n && e(i, u) && c.push(u);
    for (; s.length > l; ) e(i, u = s[l++]) && (~r(c, u) || c.push(u));
    return c;
  }, lt;
}
var dt, Fr;
function Wn() {
  return Fr || (Fr = 1, dt = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")), dt;
}
var ft, Lr;
function xo() {
  if (Lr) return ft;
  Lr = 1;
  var e = Io(), t = Wn();
  return ft = Object.keys || function(n) {
    return e(n, t);
  }, ft;
}
var pt, Hr;
function jo() {
  if (Hr) return pt;
  Hr = 1;
  var e = ye(), t = Se(), r = xo();
  return pt = oe() ? Object.defineProperties : function(o, s) {
    t(o);
    for (var i = r(s), l = i.length, c = 0, u; l > c; ) e.f(o, u = i[c++], s[u]);
    return o;
  }, pt;
}
var vt, Wr;
function wo() {
  if (Wr) return vt;
  Wr = 1;
  var e = X().document;
  return vt = e && e.documentElement, vt;
}
var ht, Ur;
function To() {
  if (Ur) return ht;
  Ur = 1;
  var e = Se(), t = jo(), r = Wn(), n = Wt()("IE_PROTO"), o = function() {
  }, s = "prototype", i = function() {
    var l = Pn()("iframe"), c = r.length, u = "<", d = ">", f;
    for (l.style.display = "none", wo().appendChild(l), l.src = "javascript:", f = l.contentWindow.document, f.open(), f.write(u + "script" + d + "document.F=Object" + u + "/script" + d), f.close(), i = f.F; c--; ) delete i[s][r[c]];
    return i();
  };
  return ht = Object.create || function(c, u) {
    var d;
    return c !== null ? (o[s] = e(c), d = new o(), o[s] = null, d[n] = c) : d = i(), u === void 0 ? d : t(d, u);
  }, ht;
}
var mt = { exports: {} }, Vr;
function H() {
  if (Vr) return mt.exports;
  Vr = 1;
  var e = Ln()("wks"), t = Hn(), r = X().Symbol, n = typeof r == "function", o = mt.exports = function(s) {
    return e[s] || (e[s] = n && r[s] || (n ? r : t)("Symbol." + s));
  };
  return o.store = e, mt.exports;
}
var bt, Yr;
function Un() {
  if (Yr) return bt;
  Yr = 1;
  var e = ye().f, t = Ie(), r = H()("toStringTag");
  return bt = function(n, o, s) {
    n && !t(n = s ? n : n.prototype, r) && e(n, r, { configurable: !0, value: o });
  }, bt;
}
var _t, Gr;
function Oo() {
  if (Gr) return _t;
  Gr = 1;
  var e = To(), t = $n(), r = Un(), n = {};
  return ae()(n, H()("iterator"), function() {
    return this;
  }), _t = function(o, s, i) {
    o.prototype = e(n, { next: t(1, i) }), r(o, s + " Iterator");
  }, _t;
}
var gt, zr;
function Ro() {
  if (zr) return gt;
  zr = 1;
  var e = $t();
  return gt = function(t) {
    return Object(e(t));
  }, gt;
}
var St, Kr;
function ko() {
  if (Kr) return St;
  Kr = 1;
  var e = Ie(), t = Ro(), r = Wt()("IE_PROTO"), n = Object.prototype;
  return St = Object.getPrototypeOf || function(o) {
    return o = t(o), e(o, r) ? o[r] : typeof o.constructor == "function" && o instanceof o.constructor ? o.constructor.prototype : o instanceof Object ? n : null;
  }, St;
}
var yt, Jr;
function Vn() {
  if (Jr) return yt;
  Jr = 1;
  var e = An(), t = Fn(), r = _o(), n = ae(), o = se(), s = Oo(), i = Un(), l = ko(), c = H()("iterator"), u = !([].keys && "next" in [].keys()), d = "@@iterator", f = "keys", p = "values", v = function() {
    return this;
  };
  return yt = function(b, h, m, _, g, S, w) {
    s(m, h, _);
    var x = function(F) {
      if (!u && F in B) return B[F];
      switch (F) {
        case f:
          return function() {
            return new m(this, F);
          };
        case p:
          return function() {
            return new m(this, F);
          };
      }
      return function() {
        return new m(this, F);
      };
    }, I = h + " Iterator", T = g == p, q = !1, B = b.prototype, P = B[c] || B[d] || g && B[g], U = P || x(g), Xn = g ? T ? x("entries") : U : void 0, Yt = h == "Array" && B.entries || P, te, ce, V;
    if (Yt && (V = l(Yt.call(new b())), V !== Object.prototype && V.next && (i(V, I, !0), !e && typeof V[c] != "function" && n(V, c, v))), T && P && P.name !== p && (q = !0, U = function() {
      return P.call(this);
    }), (!e || w) && (u || q || !B[c]) && n(B, c, U), o[h] = U, o[I] = v, g)
      if (te = {
        values: T ? U : x(p),
        keys: S ? U : x(f),
        entries: Xn
      }, w) for (ce in te)
        ce in B || r(B, ce, te[ce]);
      else t(t.P + t.F * (u || q), h, te);
    return te;
  }, yt;
}
var It, Zr;
function Bo() {
  if (Zr) return It;
  Zr = 1;
  var e = lo(), t = fo(), r = se(), n = Ft();
  return It = Vn()(Array, "Array", function(o, s) {
    this._t = n(o), this._i = 0, this._k = s;
  }, function() {
    var o = this._t, s = this._k, i = this._i++;
    return !o || i >= o.length ? (this._t = void 0, t(1)) : s == "keys" ? t(0, i) : s == "values" ? t(0, o[i]) : t(0, [i, o[i]]);
  }, "values"), r.Arguments = r.Array, e("keys"), e("values"), e("entries"), It;
}
var Qr;
function Yn() {
  if (Qr) return or;
  Qr = 1, Bo();
  for (var e = X(), t = ae(), r = se(), n = H()("toStringTag"), o = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), s = 0; s < o.length; s++) {
    var i = o[s], l = e[i], c = l && l.prototype;
    c && !c[n] && t(c, n, i), r[i] = r.Array;
  }
  return or;
}
var Xr = {}, xt, en;
function Mo() {
  if (en) return xt;
  en = 1;
  var e = Ht(), t = $t();
  return xt = function(r) {
    return function(n, o) {
      var s = String(t(n)), i = e(o), l = s.length, c, u;
      return i < 0 || i >= l ? r ? "" : void 0 : (c = s.charCodeAt(i), c < 55296 || c > 56319 || i + 1 === l || (u = s.charCodeAt(i + 1)) < 56320 || u > 57343 ? r ? s.charAt(i) : c : r ? s.slice(i, i + 2) : (c - 55296 << 10) + (u - 56320) + 65536);
    };
  }, xt;
}
var tn;
function Gn() {
  if (tn) return Xr;
  tn = 1;
  var e = Mo()(!0);
  return Vn()(String, "String", function(t) {
    this._t = String(t), this._i = 0;
  }, function() {
    var t = this._t, r = this._i, n;
    return r >= t.length ? { value: void 0, done: !0 } : (n = e(t, r), this._i += n.length, { value: n, done: !1 });
  }), Xr;
}
var jt, rn;
function zn() {
  if (rn) return jt;
  rn = 1;
  var e = Nn(), t = H()("toStringTag"), r = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) == "Arguments", n = function(o, s) {
    try {
      return o[s];
    } catch {
    }
  };
  return jt = function(o) {
    var s, i, l;
    return o === void 0 ? "Undefined" : o === null ? "Null" : typeof (i = n(s = Object(o), t)) == "string" ? i : r ? e(s) : (l = e(s)) == "Object" && typeof s.callee == "function" ? "Arguments" : l;
  }, jt;
}
var wt, nn;
function Do() {
  if (nn) return wt;
  nn = 1;
  var e = zn(), t = H()("iterator"), r = se();
  return wt = ee().isIterable = function(n) {
    var o = Object(n);
    return o[t] !== void 0 || "@@iterator" in o || r.hasOwnProperty(e(o));
  }, wt;
}
var Tt, sn;
function Eo() {
  return sn || (sn = 1, Yn(), Gn(), Tt = Do()), Tt;
}
var Ot, on;
function qo() {
  return on || (on = 1, Ot = { default: Eo(), __esModule: !0 }), Ot;
}
var Rt, an;
function No() {
  if (an) return Rt;
  an = 1;
  var e = zn(), t = H()("iterator"), r = se();
  return Rt = ee().getIteratorMethod = function(n) {
    if (n != null) return n[t] || n["@@iterator"] || r[e(n)];
  }, Rt;
}
var kt, cn;
function Ao() {
  if (cn) return kt;
  cn = 1;
  var e = Se(), t = No();
  return kt = ee().getIterator = function(r) {
    var n = t(r);
    if (typeof n != "function") throw TypeError(r + " is not iterable!");
    return e(n.call(r));
  }, kt;
}
var Bt, un;
function Co() {
  return un || (un = 1, Yn(), Gn(), Bt = Ao()), Bt;
}
var Mt, ln;
function Po() {
  return ln || (ln = 1, Mt = { default: Co(), __esModule: !0 }), Mt;
}
var dn;
function $o() {
  if (dn) return de;
  dn = 1, de.__esModule = !0;
  var e = qo(), t = o(e), r = Po(), n = o(r);
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
  return de.default = /* @__PURE__ */ (function() {
    function s(i, l) {
      var c = [], u = !0, d = !1, f = void 0;
      try {
        for (var p = (0, n.default)(i), v; !(u = (v = p.next()).done) && (c.push(v.value), !(l && c.length === l)); u = !0)
          ;
      } catch (b) {
        d = !0, f = b;
      } finally {
        try {
          !u && p.return && p.return();
        } finally {
          if (d) throw f;
        }
      }
      return c;
    }
    return function(i, l) {
      if (Array.isArray(i))
        return i;
      if ((0, t.default)(Object(i)))
        return s(i, l);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  })(), de;
}
var fe = {}, fn = {}, pn;
function Fo() {
  if (pn) return fn;
  pn = 1;
  var e = Fn();
  return e(e.S + e.F * !oe(), "Object", { defineProperty: ye().f }), fn;
}
var Dt, vn;
function Lo() {
  if (vn) return Dt;
  vn = 1, Fo();
  var e = ee().Object;
  return Dt = function(r, n, o) {
    return e.defineProperty(r, n, o);
  }, Dt;
}
var Et, hn;
function Ho() {
  return hn || (hn = 1, Et = { default: Lo(), __esModule: !0 }), Et;
}
var mn;
function Wo() {
  if (mn) return fe;
  mn = 1, fe.__esModule = !0;
  var e = Ho(), t = r(e);
  function r(n) {
    return n && n.__esModule ? n : { default: n };
  }
  return fe.default = function(n, o, s) {
    return o in n ? (0, t.default)(n, o, {
      value: s,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : n[o] = s, n;
  }, fe;
}
var pe = {}, bn;
function Uo() {
  if (bn) return pe;
  bn = 1, Object.defineProperty(pe, "__esModule", {
    value: !0
  });
  var e = {
    "13/8": "2.62",
    "15/8": "2.87",
    "11/8": "2.37",
    "8/13": "1.61",
    "2/7": "1.28",
    "1/8": "1.12",
    "123/200": "1.62"
  };
  return pe.default = e, pe;
}
var _n;
function Vo() {
  if (_n) return L;
  _n = 1, Object.defineProperty(L, "__esModule", {
    value: !0
  }), L.formatSingleOdds = L.formatOdds = void 0;
  var e = $o(), t = c(e), r = Wo(), n = c(r), o, s = qn(), i = Uo(), l = c(i);
  function c(m) {
    return m && m.__esModule ? m : { default: m };
  }
  var u = function(_, g) {
    var S = _ + "/" + g, w = l.default[S];
    return w !== void 0 ? w : (_ / g + 1).toFixed(2);
  }, d = function(_, g) {
    if (_ >= g) {
      var S = 100 * (_ / g);
      return "+" + S.toFixed(0);
    }
    var w = -100 / (_ / g);
    return w.toFixed(0);
  }, f = function(_, g) {
    return _ === g ? "EVS" : _ + "/" + g;
  }, p = (o = {}, (0, n.default)(o, s.ODDS_FORMATS.DECIMAL, u), (0, n.default)(o, s.ODDS_FORMATS.AMERICAN, d), (0, n.default)(o, s.ODDS_FORMATS.FRACTION, f), o), v = function(_) {
    var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return g ? parseFloat(_) : parseInt(_, 10);
  }, b = function(_, g, S) {
    return !!(_ && g && S);
  }, h = L.formatOdds = function(_, g) {
    var S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : s.DEFAULT_ODDS_FORMAT, w = arguments[3], x = v(_, w), I = parseInt(g, 10), T = p[S.toLowerCase()];
    return b(T, x, I) ? T(x, I) : "";
  };
  return L.formatSingleOdds = function(_, g, S) {
    var w = _.split("/"), x = (0, t.default)(w, 2), I = x[0], T = x[1];
    return h(I, T, g, S);
  }, L;
}
var gn;
function Yo() {
  if (gn) return A;
  gn = 1, Object.defineProperty(A, "__esModule", {
    value: !0
  }), A.formatSingleOdds = A.formatOdds = A.oddsFormats = void 0;
  var e = qn(), t = Vo();
  return A.oddsFormats = e.ODDS_FORMATS, A.formatOdds = t.formatOdds, A.formatSingleOdds = t.formatSingleOdds, A;
}
var Kn = Yo();
function Jn() {
  const e = Go();
  return xn(
    (t, r) => Kn.formatOdds(t, r, e),
    [e]
  );
}
function Go() {
  const [e, t] = _e(
    Ko()
  );
  return N(() => {
    const r = wn(
      "onOddsFormatChanged",
      (n, o) => {
        t(o);
      }
    );
    return () => {
      Tn(r);
    };
  }, []), e;
}
function zo() {
  const e = localStorage.getItem("Sportsbook");
  if (e)
    try {
      const { oddsFormat: t } = JSON.parse(e);
      return Object.values(Kn.oddsFormats).includes(t) ? t : void 0;
    } catch {
      return;
    }
}
function Ko() {
  return zo() || "fraction";
}
const Jo = "sb-bet-builder-container__qGDii", Zo = "sb-bet-builder-text__fQ-5-", Qo = "sb-bet-builder-odds__L7Oo3", qt = {
  container: Jo,
  text: Zo,
  odds: Qo
}, Xo = ({ price: e, isSelectionActive: t }) => {
  const r = O(), n = Jn();
  return /* @__PURE__ */ a.jsxs("div", { className: qt.container, children: [
    /* @__PURE__ */ a.jsx(k, { className: qt.text, children: r("betslip.bet_builder") }),
    /* @__PURE__ */ a.jsx(k, { className: qt.odds, children: t && (e != null && e.numerator) && (e != null && e.denominator) ? n(e.numerator, e.denominator) : "N/A" })
  ] });
}, ea = "sb-bet-builder-info__DgdMh", ta = "sb-bet-builder-disclaimer__YG2E3", ra = "sb-bet-builder-container__hRB6i", na = "sb-bet-builder-buttons__FC2zK", ia = "sb-bet-builder-viewSelectionsButton__TwZbH", sa = "sb-bet-builder-addToBetslipButton__MNVFr", J = {
  info: ea,
  disclaimer: ta,
  container: ra,
  buttons: na,
  viewSelectionsButton: ia,
  addToBetslipButton: sa
}, oa = () => {
  const {
    price: e,
    config: t,
    activeSelectionIds: r,
    isBetslipExpanded: n,
    setIsBetslipExpanded: o,
    addToBetslip: s,
    updateBetslip: i,
    getSelection: l
  } = j(), c = O(), { onOpenChange: u } = Pt(), d = r.map(l).some((v) => (v == null ? void 0 : v.active) === !1);
  if (!t)
    return null;
  const f = r.length >= t.minSelections, p = f && !d;
  return /* @__PURE__ */ a.jsxs("div", { children: [
    /* @__PURE__ */ a.jsx("div", { className: J.disclaimer, "data-test-id": "pre-betslip-disclaimer", children: /* @__PURE__ */ a.jsx(k, { variant: "labelSecondary", children: c(`disclaimers.${t.sportId}`) }) }),
    /* @__PURE__ */ a.jsxs("div", { className: J.container, children: [
      (d || r.length === 1) && /* @__PURE__ */ a.jsx(
        "div",
        {
          className: J.info,
          "data-test-id": "pre-betslip-selection-info",
          children: /* @__PURE__ */ a.jsx(k, { children: c(d ? "betslip.suspended_selection_msg" : "betslip.one_more_selection_msg") })
        }
      ),
      p && /* @__PURE__ */ a.jsx(Xo, { isSelectionActive: !d, price: e }),
      (!n || f) && /* @__PURE__ */ a.jsxs("div", { className: J.buttons, "data-test-id": "footer-buttons", children: [
        !n && /* @__PURE__ */ a.jsx(
          ne,
          {
            className: J.viewSelectionsButton,
            variant: "secondary",
            size: "small",
            onClick: () => o(!0),
            children: c("betslip.view_selections")
          }
        ),
        p && /* @__PURE__ */ a.jsx(
          ne,
          {
            className: J.addToBetslipButton,
            variant: "ghost",
            size: "small",
            onClick: () => {
              t.betslipBetId ? i() : s(), u(!1);
            },
            children: t.betslipBetId ? c("betslip.update_betslip") : c("betslip.add_to_betslip")
          }
        )
      ] })
    ] })
  ] });
}, aa = () => {
  const { isBetslipExpanded: e } = j();
  return /* @__PURE__ */ a.jsxs("div", { className: Ms.preBetslip, children: [
    e ? /* @__PURE__ */ a.jsx(Zs, {}) : /* @__PURE__ */ a.jsx(uo, {}),
    /* @__PURE__ */ a.jsx(oa, {})
  ] });
}, ca = "sb-bet-builder-container__FVwMF", ua = "sb-bet-builder-open__tvKyU", Sn = {
  container: ca,
  open: ua
}, la = () => {
  const { activeSelectionIds: e } = j();
  return /* @__PURE__ */ a.jsx(
    di,
    {
      className: Z(Sn.container, {
        [Sn.open]: e.length > 0
      }),
      "data-test-id": "pre-betslip",
      children: /* @__PURE__ */ a.jsx(aa, {})
    }
  );
}, da = "sb-bet-builder-icon__sR2Lp", fa = "sb-bet-builder-text__j4Ah9", pa = "sb-bet-builder-container__ZN3-C", va = "sb-bet-builder-highlight__c3nZj", ve = {
  icon: da,
  text: fa,
  container: pa,
  highlight: va
}, W = ({
  variant: e = "default",
  children: t
}) => /* @__PURE__ */ a.jsxs(
  fi,
  {
    className: Z(ve.container, {
      [ve.highlight]: e === "highlight"
    }),
    children: [
      /* @__PURE__ */ a.jsx(
        Ti,
        {
          size: e === "highlight" ? 16 : 12,
          className: ve.icon
        }
      ),
      /* @__PURE__ */ a.jsx(k, { className: ve.text, children: t })
    ]
  }
), Zn = (e) => e.result === "VOID", xe = (e) => !e.selections.some(Zn), ha = (e) => {
  const t = O(), r = j(), n = R(
    () => e.outcomes.map((s) => ({
      id: e.markets[s].id,
      name: s
    })),
    [e]
  ), o = R(
    () => {
      var s;
      return r.getSelections((s = Object.values(e.markets)[0]) == null ? void 0 : s.selectionIds).map((i) => {
        var c, u;
        return {
          runner: { ...(u = (c = r.byoData.metadata) == null ? void 0 : c.runners) == null ? void 0 : u[i.name], name: i.name },
          selections: Object.keys(e.markets).map((d) => {
            const f = e.markets[d], p = r.getSelections(f.selectionIds).find((v) => v.name === i.name);
            return p ? {
              ...p,
              marketId: f.id,
              marketName: d
            } : null;
          }).filter((d) => !!d)
        };
      }).filter(xe).sort(ge);
    },
    [e, r]
  );
  return /* @__PURE__ */ a.jsxs("div", { children: [
    /* @__PURE__ */ a.jsx(W, { children: t(`racing.explainers.${y.TopN}`) }),
    /* @__PURE__ */ a.jsx(
      ie,
      {
        columns: n,
        rows: o,
        onToggleSelection: (s) => r.toggleSelection(s),
        isSelected: (s) => r.isSelected(s),
        isDisabled: (s) => r.isDisabled(s)
      }
    )
  ] });
}, ma = (e) => {
  const t = O(), r = j(), n = R(
    () => e.outcomes.map((s) => ({
      id: e.markets[s].id,
      name: s
    })),
    [e]
  ), o = R(
    () => {
      var s;
      return r.getSelections((s = Object.values(e.markets)[0]) == null ? void 0 : s.selectionIds).map((i) => {
        var c, u;
        return {
          runner: { ...(u = (c = r.byoData.metadata) == null ? void 0 : c.runners) == null ? void 0 : u[i.name], name: i.name },
          selections: Object.keys(e.markets).map((d) => {
            const f = e.markets[d], p = r.getSelections(f.selectionIds).find((v) => v.name === i.name);
            return p ? {
              ...p,
              marketId: f.id,
              marketName: d
            } : null;
          }).filter((d) => !!d)
        };
      }).filter(xe).sort(ge);
    },
    [e, r]
  );
  return /* @__PURE__ */ a.jsxs("div", { children: [
    /* @__PURE__ */ a.jsx(W, { children: t(`racing.explainers.${y.ToFinishNth}`) }),
    /* @__PURE__ */ a.jsx(
      ie,
      {
        columns: n,
        rows: o,
        onToggleSelection: (s) => r.toggleSelection(s),
        isSelected: (s) => r.isSelected(s),
        isDisabled: (s) => r.isDisabled(s)
      }
    )
  ] });
}, ba = (e) => {
  const t = O(), r = j(), n = R(() => e != null && e.markets ? Object.keys(e.markets).map((s) => {
    const i = e.markets[s], l = [
      { id: i.id, name: s }
    ], c = r.getSelections(i.selectionIds).map((u) => {
      var f, p;
      return {
        runner: { ...(p = (f = r.byoData.metadata) == null ? void 0 : f.runners) == null ? void 0 : p[u.name], name: u.name },
        selections: [{ ...u, marketId: i.id }]
      };
    });
    return { title: s, columns: l, rows: c };
  }).filter(
    ({ rows: s }) => s.every((i) => !i.selections.some(Zn))
  ) : [], [e, r]);
  return e ? /* @__PURE__ */ a.jsxs("div", { children: [
    /* @__PURE__ */ a.jsx(W, { children: t(`racing.explainers.${y.HeadToHead}`) }),
    n.map(({ title: o, columns: s, rows: i }) => /* @__PURE__ */ a.jsxs("div", { "data-test-id": "head-to-head-section-group", children: [
      /* @__PURE__ */ a.jsx(pi, { level: 5, children: o }),
      /* @__PURE__ */ a.jsx(
        ie,
        {
          rows: i,
          columns: s,
          onToggleSelection: (l) => r.toggleSelection(l),
          isSelected: (l) => r.isSelected(l),
          isDisabled: (l) => r.isDisabled(l),
          showHeader: !1,
          showDivider: !1
        }
      )
    ] }, s[0].id))
  ] }) : null;
}, _a = (e) => {
  const t = O(), r = j(), n = R(
    () => [{ id: e.id, name: "BWO" }],
    [e.id]
  ), o = R(() => {
    const s = e.markets;
    return r.getSelections(s.selectionIds).map((i) => {
      var c, u;
      return {
        runner: { ...(u = (c = r.byoData.metadata) == null ? void 0 : c.runners) == null ? void 0 : u[i.name], name: i.name },
        selections: [{ ...i, marketId: e.id }]
      };
    }).filter(xe).sort(ge);
  }, [e, r]);
  return /* @__PURE__ */ a.jsxs("div", { children: [
    /* @__PURE__ */ a.jsx(W, { children: t(`racing.explainers.${y.BettingWithoutOne}`) }),
    /* @__PURE__ */ a.jsx(
      ie,
      {
        columns: n,
        rows: o,
        onToggleSelection: (s) => r.toggleSelection(s),
        isSelected: (s) => r.isSelected(s),
        isDisabled: (s) => r.isDisabled(s),
        showHeader: !1,
        showDivider: !1
      }
    )
  ] });
}, ga = (e) => {
  const t = O(), r = j(), n = R(
    () => [{ id: e.id, name: "BWT" }],
    [e.id]
  ), o = R(() => {
    const s = e.markets;
    return r.getSelections(s.selectionIds).map((i) => {
      var c, u;
      return {
        runner: { ...(u = (c = r.byoData.metadata) == null ? void 0 : c.runners) == null ? void 0 : u[i.name], name: i.name },
        selections: [{ ...i, marketId: e.id }]
      };
    }).filter(xe).sort(ge);
  }, [e, r]);
  return /* @__PURE__ */ a.jsxs("div", { children: [
    /* @__PURE__ */ a.jsx(W, { children: t(`racing.explainers.${y.BettingWithoutTwo}`) }),
    /* @__PURE__ */ a.jsx(
      ie,
      {
        columns: n,
        rows: o,
        onToggleSelection: (s) => r.toggleSelection(s),
        isSelected: (s) => r.isSelected(s),
        isDisabled: (s) => r.isDisabled(s),
        showHeader: !1,
        showDivider: !1
      }
    )
  ] });
}, Sa = "sb-bet-builder-container__plQ-a", ya = "sb-bet-builder-groupContainer__TE8-p", Ia = "sb-bet-builder-groupTitleContainer__ojeQk", xa = "sb-bet-builder-buttonGroup__VWzSG", he = {
  container: Sa,
  groupContainer: ya,
  groupTitleContainer: Ia,
  buttonGroup: xa
}, ja = (e) => {
  const t = j(), r = O(), n = Jn(), o = R(() => {
    const s = [], i = t.getSelections(e.markets.selectionIds);
    for (let l = 0; l < i.length; l += 2)
      s.push(i.slice(l, l + 2));
    return s;
  }, [e, t]);
  return /* @__PURE__ */ a.jsxs("div", { children: [
    /* @__PURE__ */ a.jsx(W, { children: r(`racing.explainers.${y.Distance}`) }),
    /* @__PURE__ */ a.jsx(
      "div",
      {
        className: he.container,
        "data-test-id": "winning-distance-container",
        children: o.map((s, i) => /* @__PURE__ */ a.jsxs("div", { className: he.groupContainer, children: [
          /* @__PURE__ */ a.jsx("div", { className: he.groupTitleContainer, children: s.map((l) => /* @__PURE__ */ a.jsx(k, { variant: "bodySecondary", children: l.name }, l.id)) }),
          /* @__PURE__ */ a.jsx(vi, { className: he.buttonGroup, children: s.map((l) => /* @__PURE__ */ a.jsx(
            hi,
            {
              selected: t.isSelected(l.id),
              disabled: t.isDisabled(l.id),
              onClick: () => t.toggleSelection(l.id),
              children: l.priceNum != null && l.priceDen != null ? n(l.priceNum, l.priceDen) : "N/A"
            },
            l.id
          )) })
        ] }, i))
      }
    )
  ] });
}, wa = {
  [C.HorseRacing]: {
    [y.BettingWithoutOne]: _a,
    [y.BettingWithoutTwo]: ga,
    [y.TopN]: ha,
    [y.ToFinishNth]: ma,
    [y.HeadToHead]: ba,
    [y.Distance]: ja
  }
}, Ta = "sb-bet-builder-container__YX-vq", Oa = "sb-bet-builder-explainer__8sP4D", Ra = "sb-bet-builder-group__F8Xj-", ka = "sb-bet-builder-rows__E-v00", Ba = "sb-bet-builder-row__YyrY4", Ma = "sb-bet-builder-rowSummary__0fyZQ", $ = {
  container: Ta,
  explainer: Oa,
  group: Ra,
  rows: ka,
  row: Ba,
  rowSummary: Ma
}, Da = () => /* @__PURE__ */ a.jsxs("div", { className: $.container, children: [
  /* @__PURE__ */ a.jsx("div", { className: $.explainer, children: /* @__PURE__ */ a.jsx(M, { height: 14, width: "70%" }) }),
  /* @__PURE__ */ a.jsxs("div", { children: [
    /* @__PURE__ */ a.jsx("div", { className: $.group, children: /* @__PURE__ */ a.jsx(M, { height: 20, width: "50%" }) }),
    /* @__PURE__ */ a.jsx("div", { className: $.rows, children: Array.from({ length: 9 }).map((e, t) => /* @__PURE__ */ a.jsxs("div", { className: $.row, children: [
      /* @__PURE__ */ a.jsxs("div", { className: $.rowSummary, children: [
        /* @__PURE__ */ a.jsx(M, { height: 16, width: "85%" }),
        /* @__PURE__ */ a.jsx(M, { height: 12, width: "60%" })
      ] }),
      /* @__PURE__ */ a.jsx(M, { height: 44, width: "15%" }),
      /* @__PURE__ */ a.jsx(M, { height: 44, width: "15%" }),
      /* @__PURE__ */ a.jsx(M, { height: 44, width: "15%" }),
      /* @__PURE__ */ a.jsx(M, { height: 44, width: "15%" })
    ] }, t)) }),
    /* @__PURE__ */ a.jsx("div", { className: $.group, children: /* @__PURE__ */ a.jsx(M, { height: 20, width: "70%" }) }),
    /* @__PURE__ */ a.jsx("div", { className: $.group, children: /* @__PURE__ */ a.jsx(M, { height: 20, width: "60%" }) })
  ] })
] }), Ea = "sb-bet-builder-container__nqamu", qa = {
  container: Ea
}, Na = () => {
  const { error: e } = j(), { onOpenChange: t } = Pt(), r = O();
  return /* @__PURE__ */ a.jsx("div", { className: qa.container, children: /* @__PURE__ */ a.jsx(
    Oi,
    {
      title: r("error.title"),
      subtitle: r(
        `error.description.${(e == null ? void 0 : e.errorCode) ?? E.Unknown}`
      ),
      actionLabel: r("error.close"),
      onActionClick: () => t(!1)
    }
  ) });
}, Aa = () => {
  const e = O(), {
    error: t,
    config: r,
    isLoading: n,
    isInitialized: o,
    marketGroups: s,
    visibleMarketGroupIds: i,
    isMarketGroupSuspended: l,
    isMarketGroupIncompatible: c,
    setVisibleMarketGroups: u
  } = j();
  return n ? /* @__PURE__ */ a.jsx(je, { padding: !1, children: /* @__PURE__ */ a.jsx(Da, {}) }) : t && !o ? /* @__PURE__ */ a.jsx(je, { padding: !1, children: /* @__PURE__ */ a.jsx(Na, {}) }) : r ? /* @__PURE__ */ a.jsxs(je, { padding: !1, children: [
    /* @__PURE__ */ a.jsx(W, { variant: "highlight", children: e("header.explainer", {
      min: r.minSelections,
      max: r.maxSelections
    }) }),
    s.filter((d) => !l(d.id)).map((d) => {
      const f = wa[r.sportId][d.category];
      return /* @__PURE__ */ a.jsxs(
        mi,
        {
          open: i.includes(d.id),
          onOpenChange: (p) => {
            u(
              p ? [...i, d.id] : i.filter((v) => v !== d.id)
            );
          },
          children: [
            /* @__PURE__ */ a.jsx(bi, { children: d.categoryName }),
            /* @__PURE__ */ a.jsxs(_i, { children: [
              c(d.id) && /* @__PURE__ */ a.jsx(gi, { variant: "info", children: e("error.market_combination_error") }),
              /* @__PURE__ */ a.jsx(f, { ...d })
            ] })
          ]
        },
        d.id
      );
    })
  ] }) : null;
};
var Ca = "price", Pa = "wh.push.ready", $a = "sports", Fa = "byo-price-updates", yn = "byo-event-updates";
function La(e) {
  return function(r, n) {
    e.subscribe(r, function(o, s) {
      e.unsubscribe(r), n(s);
    });
  };
}
function Ha(e) {
  var t = e.messageBus, r = e.readyTopic, n = e.operationSelector, o = new Promise(function(i) {
    La(t)(r, i);
  }), s = {
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
    UNSUBSCRIBE_ALL: "unsubscribeAll"
  };
  return {
    subscribe: function(l) {
      return new Promise(function(c) {
        o.then(function() {
          var u;
          (u = n(s.SUBSCRIBE)) === null || u === void 0 || u(l), c();
        });
      });
    },
    unsubscribe: function(l) {
      return new Promise(function(c) {
        o.then(function() {
          var u;
          (u = n(s.UNSUBSCRIBE)) === null || u === void 0 || u(l), c();
        });
      });
    },
    unsubscribeAll: function(l) {
      return new Promise(function(c) {
        o.then(function() {
          var u;
          (u = n(s.UNSUBSCRIBE_ALL)) === null || u === void 0 || u(l), c();
        });
      });
    }
  };
}
function Wa(e) {
  return window.subscriptionManager[e];
}
var Qn = Ha({
  messageBus: yi,
  operationSelector: Wa,
  readyTopic: Pa
}), Ut = Qn.subscribe, me = Qn.unsubscribe;
const Vt = "byo-modal", Nt = (e, t) => {
  const r = new Map(t.map((s) => [s.id, s])), n = new Map(e.map((s) => [s.id, s])), o = e.map((s) => {
    const i = r.get(s.id);
    return i ? { ...s, ...i } : s;
  });
  return t.forEach((s) => {
    n.has(s.id) || o.push(s);
  }), o;
}, Ua = (e = !0) => {
  const { config: t } = j();
  N(() => {
    if (!t || !e)
      return;
    const r = {
      type: yn,
      owner: Vt,
      locale: t.locale === "es-es" ? "es" : "en",
      eventId: t.eventId,
      callback: (n) => {
        const o = n == null ? void 0 : n.data;
        window.location.search.includes("debug=1") && console.debug(yn, n);
        const s = Bn(o, t);
        Q.setState((i) => ({
          byoData: i.byoData ? { ...i.byoData, active: o.active } : null,
          marketGroups: Nt(i.marketGroups, s.marketGroups),
          markets: Nt(i.markets, s.markets),
          selections: Nt(i.selections, s.selections)
        }));
      }
    };
    return Ut(r), () => {
      me(r);
    };
  }, [t, e]);
}, Va = (e = !0) => {
  const { priceSubscription: t } = j(), r = t == null ? void 0 : t.topic;
  N(() => {
    if (!r || !e)
      return;
    const n = {
      type: Fa,
      owner: Vt,
      topic: r,
      callback: (o) => {
        var i;
        const s = (i = o == null ? void 0 : o.data) == null ? void 0 : i.price;
        s && Q.setState({ price: s });
      }
    };
    return Ut(n), () => {
      me(n);
    };
  }, [r, e]);
}, Ya = (e = !0) => {
  const { selections: t, visibleMarketGroupIds: r } = j(), n = ei(
    /* @__PURE__ */ new Map()
  ), o = R(
    () => e ? t.filter(
      (s) => r.includes(s.marketGroupId)
    ) : [],
    [t, r, e]
  );
  N(() => {
    const s = new Set(o.map((i) => i.id));
    n.current.forEach((i, l) => {
      s.has(l) || (me(i), n.current.delete(l));
    }), o.forEach((i) => {
      if (!n.current.has(i.id)) {
        const l = {
          type: $a,
          owner: Vt,
          eventId: i.eventId,
          marketId: i.marketId,
          selectionId: i.id,
          callback: (c) => {
            if ((c == null ? void 0 : c.type) === Ca) {
              const { numerator: u, denominator: d } = c || {};
              Q.setState((f) => ({
                selections: f.selections.map(
                  (p) => p.id === i.id ? {
                    ...p,
                    priceNum: u ?? p.priceNum,
                    priceDen: d ?? p.priceDen
                  } : p
                )
              }));
            }
          }
        };
        Ut(l), n.current.set(i.id, l);
      }
    });
  }, [o]), N(() => {
    const s = n.current;
    return () => {
      s.forEach(me), s.clear();
    };
  }, []);
}, Ct = (e, t) => {
  N(() => {
    const r = wn(
      e,
      (n, o) => t(o)
    );
    return () => {
      Tn(r);
    };
  }, [e, t]);
}, Ga = () => {
  const [e, t] = _e(
    null
  );
  return Ct("gotLoginState", t), e;
}, za = (e) => {
  if (e.includes("native"))
    window.location.href = "nw-showlogin://";
  else {
    const t = document.querySelector(
      "#account-section section.account"
    );
    t == null || t.classList.add("-expanded"), At("wh.common.command.ui.login.flow.start", {});
  }
}, Ka = (e) => {
  const t = Ga();
  return N(() => {
    e.enabled && (t == null ? void 0 : t.isLoggedIn) === !1 && za(e.platform);
  }, [e, t]), {
    isLoggedIn: (t == null ? void 0 : t.isLoggedIn) === !0,
    isLoading: t === null
  };
}, Ja = (e) => {
  var t;
  return (t = window.AnalyticsTactical) == null ? void 0 : t.Sports.localHelpers.enrichWithCommonInfo(e);
};
function Za(e, t) {
  var r;
  try {
    (r = window.AnalyticsTactical) == null || r.Helpers.sendData(
      e,
      Ja(t)
    );
  } catch (n) {
    console.error("Tracking event failed with error", { err: n, value: t });
  }
}
const Qa = () => Za("link", {
  tealium_event: "sb_bet_builder_open_modal_button",
  NonInteractionEvent: "0",
  ElementType: "Standard",
  EventCategory: "Bet Builder Interactions",
  EventAction: "Open Modal",
  EventLabel: "Button"
}), sc = ({
  locale: e,
  environment: t,
  jurisdiction: r,
  platform: n,
  translations: o
}) => {
  const [s, i] = _e(null), l = Ka({ enabled: !!s, platform: n }), c = !!s && (l.isLoggedIn || l.isLoading);
  return N(() => {
    s && (l.isLoggedIn ? Q.getState().initialize(s) : l.isLoading && Q.setState({ isLoading: !0 }));
  }, [s, l.isLoggedIn, l.isLoading]), Ct("wh.sports.betbuilder.open", (u) => {
    ["sportId", "eventId"].forEach((d) => {
      if (!u[d])
        throw new Error(`Missing "${d}"`);
    }), i({
      locale: e,
      environment: t,
      jurisdiction: r,
      sportId: u.sportId,
      eventId: u.eventId,
      initialSelections: u.byoSelectionIds
    }), Qa();
  }), Ct("wh.sports.betbuilder.edit", (u) => {
    ["id", "sportId", "eventId", "byoSelectionIds"].forEach((d) => {
      if (!u[d])
        throw new Error(`Missing "${d}"`);
    }), i({
      locale: e,
      environment: t,
      jurisdiction: r,
      betslipBetId: u.id,
      sportId: u.sportId,
      eventId: u.eventId,
      initialSelections: u.byoSelectionIds
    });
  }), Ua(c), Va(c), Ya(c), /* @__PURE__ */ a.jsx(Ci, { translations: o, children: /* @__PURE__ */ a.jsx(
    ls,
    {
      open: c,
      onOpenChange: () => i(null),
      children: /* @__PURE__ */ a.jsx(Si, { children: /* @__PURE__ */ a.jsxs(fs, { children: [
        /* @__PURE__ */ a.jsx(ks, {}),
        /* @__PURE__ */ a.jsx(Aa, {}),
        /* @__PURE__ */ a.jsx(la, {})
      ] }) })
    }
  ) });
};
export {
  sc as BetBuilderModal
};
//# sourceMappingURL=index.js.map
